import { each, on } from '../helpers/shortcuts';
import shared from './shared';

export default () => {
  const items = document.querySelectorAll('.c-calendar__item');

  if (items.length < 2) {
    return;
  }

  const data = [];
  let maxCount = 0;

  each(items, item => {
    const slots = item.querySelectorAll('.c-calendar__slot');
    const slotsData = [];
    maxCount = Math.max(maxCount, slots.length);

    each(slots, slot => {
      slotsData.push(slot);
    });

    data.push(slotsData);
  });

  const updateGrid = () => {
    for (let i = 0; i < maxCount; i += 1) {
      let maxHeight = 0;

      for (let ii = 0; ii < data.length; ii += 1) {
        const slot = data[ii][i];

        if (slot !== undefined) {
          slot.style.height = null;
          maxHeight = Math.max(maxHeight, slot.getBoundingClientRect().height);
        }
      }

      if (shared.windowWidth >= shared.breakpoints.large) {
        for (let ii = 0; ii < data.length; ii += 1) {
          const slot = data[ii][i];

          if (slot) {
            slot.style.height = `${maxHeight}px`;
          }
        }
      }
    }
  };

  if (shared.windowWidth >= shared.breakpoints.large) {
    updateGrid();
  }

  on('resize', window, updateGrid);
};



// WEBPACK FOOTER //
// ./src/scripts/modules/calendar.js